import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appAddTargetBlankNoOpener]',
})
export class AddTargetBlankNoOpenerDirective {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {
        this.addTargetBlankNoOpener();
    }

    private addTargetBlankNoOpener(): void {
        const anchor = this.el.nativeElement;

        if (anchor.tagName.toUpperCase() === 'A') {
            // Set target="_blank"
            this.renderer.setAttribute(anchor, 'target', '_blank');

            // Check if rel attribute exists and includes 'noopener'
            const relAttribute = anchor.getAttribute('rel');

            if (!relAttribute || !relAttribute.includes('noopener')) {
                this.renderer.setAttribute(anchor, 'rel', 'noopener');
            }
        }
    }
}
